// src/services/SMTPService.js
import axios from 'axios';
import config from '../config';

const SMTPService = {
  get: async () => {
    const response = await axios.get(`${config.apiBaseUrl}/smtp-config`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(`${config.apiBaseUrl}/smtp-config`, data);
    return response.data;
  },

  update: async (data) => {
    const response = await axios.put(`${config.apiBaseUrl}/smtp-config`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${config.apiBaseUrl}/smtp-config/${id}`);
    return response.data;
  },
};

export default SMTPService;
